<template>
  <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
    <!-- Unit Log -->
    <b-form-group :label="$t('patrol_logs.patrol_log.unit_log')" label-for="id_unit_log">
      <v-select
        id="id_unit_log"
        v-model="formData.id_unit_log"
        :options="unitLogOptions"
        :reduce="(val) => val.value"
        :clearable="false"
        :placeholder="$t('patrol_logs.patrol_log.select_unit_log')"
      />
    </b-form-group>

    <!-- Unit -->
    <b-form-group :label="$t('patrol_logs.patrol_log.unit')" label-for="id_unit">
      <v-select
        id="id_unit"
        v-model="formData.id_unit"
        :options="unitOptions"
        :reduce="(val) => val.value"
        :clearable="false"
        :placeholder="$t('patrol_logs.patrol_log.select_unit')"
      />
    </b-form-group>

    <!-- Shipping Time -->
    <!-- :disabled="!isAdd && (!formData.id_unit_log || !!formData.shipping_time)" -->
    <b-form-group :label="$t('patrol_logs.patrol_log.shipping_time')" label-for="shipping_time">
      <b-form-input
        id="shipping_time"
        v-model="formData.shipping_time"
        type="datetime-local"
      />
    </b-form-group>

    <!-- Arrival Time -->
    <b-form-group :label="$t('patrol_logs.patrol_log.arrival_time')" label-for="arrival_time">
      <b-form-input
        id="arrival_time"
        v-model="formData.arrival_time"
        type="datetime-local"
      />
    </b-form-group>

    <!-- Departure Time -->
    <b-form-group :label="$t('patrol_logs.patrol_log.departure_time')" label-for="departure_time">
      <b-form-input
        id="departure_time"
        v-model="formData.departure_time"
        type="datetime-local"
      />
    </b-form-group>

    <!-- Revision Code -->
    <b-form-group :label="$t('patrol_logs.patrol_log.revision_code')" label-for="id_revision_code">
      <v-select
        id="id_revision_code"
        v-model="formData.id_revision_code"
        :options="revisionCodeOptions"
        :reduce="(val) => val.value"
        :clearable="true"
        :placeholder="$t('patrol_logs.patrol_log.select_revision_code')"
      />
    </b-form-group>

    <!-- Comments -->
    <b-form-group :label="$t('patrol_logs.patrol_log.comments')" label-for="comments">
      <b-form-textarea
        id="comments"
        v-model="formData.comments"
        :placeholder="$t('patrol_logs.patrol_log.comments')"
        rows="3"
        trim
      />
    </b-form-group>

    <!-- surveillance -->
    <b-form-group :label="$t('patrol_logs.patrol_log.surveillance')" label-for="surveillance">
      <b-form-checkbox id="surveillance" v-model="formData.surveillance" switch>
      </b-form-checkbox>
    </b-form-group>

    <!-- Form Actions -->
    <div class="d-flex mt-2">
      <b-button variant="primary" class="mr-2" type="submit">
        {{ isAdd ? $t('actions.add') : $t('actions.update') }}
      </b-button>
      <b-button variant="outline-secondary" type="reset">
        {{ $t('actions.cancel') }}
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BFormTextarea, BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    vSelect,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    unitOptions: {
      type: Array,
      default: () => [],
    },
    unitLogOptions: {
      type: Array,
      default: () => [],
    },
    revisionCodeOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup(_, { emit }) {
    const onSubmit = () => {
      emit('submit')
    }

    const onReset = () => {
      emit('reset')
    }

    return {
      onSubmit,
      onReset,
    }
  },
}
</script>
